(function () {
  'use strict';

  const cartApiUrl = window.cartApiUrl || '';

  async function getLeadTime(productId, variantId) {
    try {
      const res = await fetch(`${cartApiUrl}/mongo/leadtimes?shopifyProductId=${productId}&variantId=${variantId}&unit=1`);
      const json = await res.json();
      const { availableToSell, customLeadTime } = json.data;

      if (availableToSell > 30) return 'In Stock';
      if (availableToSell > 0)  return 'Only a few left!';
      if (customLeadTime)       return customLeadTime;
      return '';
    } catch {
      return '';
    }
  }

  async function getCurrentCart() {
    const res = await fetch('/cart.js');
    return res.json();
  }

  async function removeAssociatedProducts(variantId, cartData) {
    const toRemove = cartData.items.filter(item =>
      parseInt(item.properties?._associated_variant_id) === parseInt(variantId) ||
      parseInt(item.properties?._complimentary_associated_variant_id) === parseInt(variantId)
    );

    await Promise.all(toRemove.map(item =>
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: item.key, quantity: 0 })
      })
    ));
  }

  document.querySelectorAll('.addToCartFavouriteAddOn').forEach(btn => {
    btn.addEventListener('click', async function () {
      document.querySelectorAll('.addToCartFavouriteAddOn').forEach(b => b.disabled = true);
      let existingItem  = this.dataset.variantInCart;
      const variantId  = parseInt(this.dataset.variantId);
      const productId  = parseInt(this.dataset.productId);
      const isGiftWrap = this.dataset.giftWrap === 'true';
      existingItem = existingItem ? JSON.parse(existingItem) : null;
      this.textContent = 'Adding';
      this.style.cssText = 'color:white;background-color:black; opacity: 1;';

      try {
        const leadTime = await getLeadTime(productId, variantId);
        const isEngravable = this.dataset.engravable === 'true';
        const properties = {
        ...(leadTime && {
          'Lead Time': leadTime,
          '_associated_unique_key': Math.random().toString(36).substring(2)
        }),
        ...(isGiftWrap && {
          '_giftwrap': 'true'
        })
      };
      const endpoint = existingItem && !isEngravable
        ? '/cart/change.js'
        : '/cart/add.js';

      const payload = existingItem && !isEngravable
        ? {
            id: existingItem.key,
            quantity: existingItem.quantity + 1,
            properties: existingItem.properties
          }
        : {
            id: variantId,
            quantity: 1,
            properties
          };

        const response = await fetch(endpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(payload)
        });
        if (!response.ok) {
          throw new Error(await response.text());
        }
      } catch (err) {
        console.error('Add-to-cart error:', err);
      } finally {
        location.reload();
        window.scrollTo({
          top: 0,
          behavior: "smooth"
        });
      }
    });
  });
})();